import IService from "@api/iService";
import { IItem } from "@interfaces/user/items";

export default class ItemService extends IService {

    async getItems(ids: string[]) {
        return await this.getApi<IItem[]>(`/api/user/item/?` + ids.map(id => `itemId=${id}`).join('&'));
    }

    getAllItems() {
        return this.getApi<IItem[]>(`/api/user/item/all/`);
    }
}